var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 28.2",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dollar"
  }, "Money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dollar"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.4 18.2c3.8 0 7-2.9 7-6.5s-3.1-6.5-7-6.5c-3.8 0-7 2.9-7 6.5s3.1 6.5 7 6.5zm0-11.8c3.2 0 5.8 2.4 5.8 5.3s-2.6 5.3-5.8 5.3-5.8-2.4-5.8-5.3 2.6-5.3 5.8-5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1,3.6V0H0v23.7h44.1V4.8h2.6V27H4.9v-3.3H3.6v4.5H48V3.6H44.1z M1.2,7.2c3.2-0.2,5.8-2.8,6-6h30.2  c0.2,3,2.5,5.5,5.4,5.9V17c-2.7,0.5-4.9,2.6-5.4,5.4H7.2c-0.5-2.9-2.9-5.2-6-5.4C1.2,17,1.2,7.2,1.2,7.2z M42.9,5.9  c-2.3-0.5-4-2.4-4.2-4.7h4.2V5.9z M6,1.2C5.8,3.8,3.8,5.8,1.2,6V1.2H6z M1.2,18.3c2.4,0.2,4.3,1.9,4.7,4.2H1.2V18.3z M38.8,22.5  c0.4-2.1,2.1-3.7,4.1-4.1v4.1H38.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.1d51b94bf06a6835126cf6cf6ab49800.svg";
export { ForwardRef as ReactComponent };